import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ActiveCampaignProvider } from "@/contexts/ActiveCampaignContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Campaigns from "@/pages/Campaigns";
import CurveLibrary from "@/pages/CurveLibrary";
import UploadCurve from "@/pages/UploadCurve";
import VendorParameters from "@/pages/VendorParameters";
import DDF from "@/pages/DDF";
import BudgetSensitivity from "@/pages/BudgetSensitivity";
import Optimizer from "@/pages/Optimizer";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import CampaignDetail from "@/pages/CampaignDetail";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <ActiveCampaignProvider>
        <AppLayout>{children}</AppLayout>
      </ActiveCampaignProvider>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Shell><Dashboard /></Shell>} />
          <Route path="/campaigns" element={<Shell><Campaigns /></Shell>} />
          <Route path="/campaigns/:id" element={<Shell><CampaignDetail /></Shell>} />
          <Route path="/curve-library" element={<Shell><CurveLibrary /></Shell>} />
          <Route path="/upload-curve" element={<Shell><UploadCurve /></Shell>} />
          <Route path="/vendors" element={<Shell><VendorParameters /></Shell>} />
          <Route path="/ddf" element={<Shell><DDF /></Shell>} />
          <Route path="/budget-sensitivity" element={<Shell><BudgetSensitivity /></Shell>} />
          <Route path="/optimizer" element={<Shell><Optimizer /></Shell>} />
          <Route path="/reports" element={<Shell><Reports /></Shell>} />
          <Route path="/users" element={<Shell><Users /></Shell>} />
          <Route path="/settings" element={<Shell><Settings /></Shell>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
